export const Top = [
    {"label": "90 Hari", "value": "90"},
    {"label": "60 Hari", "value": "60"},
    {"label": "30 Hari", "value": "30"},
    {"label": "20 Hari", "value": "20"},
    {"label": "15 Hari", "value": "15"},
    {"label": "7 Hari", "value": "7"},
    {"label": "Cash", "value": "0"},
]

export const Currency = [
    {"label": "Rupiah", "value": "Rupiah"},
    {"label": "Dollar", "value": "Dollar"},
    {"label": "Sing", "value": "Sing"},
    {"label": "Euro", "value": "Euro"},
    {"label": "Yuan", "value": "Yuan"},
]